import { Loading } from 'components';
// import { AnimatePresence } from 'framer-motion';
import { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import {
	useIsWeChatUser,
	useProduct,
	useSDK,
	useSDKLoadingPercentage,
	useSystemActions,
	useToken,
	useUserActions,
	useWXSDK,
} from 'stores';

interface ProtectedRouteProps {
	children: ReactNode;
	reqAuth?: boolean;
	reqSDK?: boolean;
	reqCam?: boolean;
	reqProduct?: boolean;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
	const { t } = useTranslation();
	const product = useProduct();
	const { children, reqAuth, reqSDK, reqCam, reqProduct } = props;
	const {
		initializeSDK,
		setAuthMode,
		setTorchAvailability,
		setCameraInfo,
		initializeWXSDK,
	} = useSystemActions();
	const { appToken, userToken } = useToken();
	const { initToken } = useUserActions();
	const { sdk, authMode } = useSDK();
	const isWechatUser = useIsWeChatUser();
	const wxsdk = useWXSDK();
	const percentage = useSDKLoadingPercentage();

	useEffect(() => {
		if (!appToken) {
			initToken();
			return;
		}
		if (!sdk && percentage === 0 && (reqSDK || reqCam)) {
			initializeSDK();
			return;
		}
		if (
			!wxsdk &&
			isWechatUser &&
			process.env.REACT_APP_USE_WECHAT_SCAN === 'true'
		) {
			initializeWXSDK();
			return;
		}
		if (sdk && typeof authMode === 'undefined' && reqCam)
			(async () => {
				if (
					isWechatUser &&
					process.env.REACT_APP_USE_WECHAT_SCAN === 'true'
				) {
					setAuthMode(9);
					return;
				}
				// await new Promise((r) => setTimeout(r, 2000));
				await sdk.checkCameraCapability();
				let cameraCheckResult = sdk.getCameraCheckResult();
				setCameraInfo({
					maxPreviewWidth: cameraCheckResult.maxPreviewWidth,
					maxPreviewHeight: cameraCheckResult.maxPreviewHeight,
				});
				setAuthMode(sdk.getAuthMode());
				setTorchAvailability(sdk.getTorchAvailability());
				return;
			})();
	});

	if (!appToken) {
		return <Loading content={t('default.loading')} />;
	}

	if (!userToken && reqAuth) {
		return <Navigate to="/Login" replace />;
	}

	if (!product && reqProduct) {
		return <Navigate to="/" replace />;
	}

	if (!sdk && (reqSDK || reqCam)) {
		return <Loading value={percentage} content={t('scan.loadingFiles')} />;
	}

	if (
		!wxsdk &&
		isWechatUser &&
		process.env.REACT_APP_USE_WECHAT_SCAN === 'true'
	) {
		return <Loading content={t('scan.loadingwxsdk')} />;
	}

	if (typeof authMode === 'undefined' && reqCam) {
		return <Loading content={t('scan.checkCompatibility')} />;
	}

	// return <AnimatePresence mode="wait">{children}</AnimatePresence>;
	return <>{children}</>;
};

export default ProtectedRoute;
